var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChannelWinblows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1618FE53-41E2-4B6F-97A7-DA642703DF5F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-811.000000, -3042.000000)",
    id: "channel_winblows"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(811.000000, 3042.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "BG-1",
    opacity: 0.579999983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,5.66666667 L17,15.5833333 L31.1666667,15.5833333 L31.1666667,2.83333333 L17,5.66666667 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,28.3333333 L17,18.4166667 L31.1666667,18.4166667 L31.1666667,31.1666667 L17,28.3333333 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83333333,8.5000689 L2.83333333,15.5834022 L14.1666667,15.5834022 L14.1666667,6.09173584 L2.83333333,8.5000689 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83333333,25.5 L2.83333333,18.4166667 L14.1666667,18.4166667 L14.1666667,27.9083344 L2.83333333,25.5 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelWinblows);
export default __webpack_public_path__ + "static/media/channel_winblows.c76e1bc401511c1d935f369db6a3ce62.svg";
export { ForwardRef as ReactComponent };